import http from '@/services/http'

export default {
  getState,
  getMutations,
  getActions,
}

export function getState() {
  return {
    entries: [],
    totalCount: 0,
    fetchInProgress: false,
    addInProgress: false,
    updateInProgress: false,
  }
}

export function getMutations() {
  return {
    startFetch(state) {
      state.fetchInProgress = true
    },
    stopFetch(state) {
      state.fetchInProgress = false
    },

    startAdd(state) {
      state.addInProgress = true
    },
    stopAdd(state) {
      state.addInProgress = false
    },
    addEntry(state, { entry }) {
      state.entries = state.entries.concat([entry])
    },
    setEntries(state, { entries, totalCount }) {
      state.entries = entries
      state.totalCount = totalCount
    },
    remove(state, { entryId }) {
      state.entries = state.entries.filter((e) => e.id !== entryId)
    },

    startUpdate(state) {
      state.updateInProgress = true
    },
    stopUpdate(state) {
      state.updateInProgress = false
    },
    update(state, { entry }) {
      state.entries = state.entries.map((e) => {
        if (e.id === entry.id) {
          return { ...e, ...entry }
        } else {
          return e
        }
      })
    },
  }
}

export function getActions({
  getQueryUrl,
  queryIsPaginated = false,
  getUpdateUrl,
  getAddUrl,
}) {
  // getQueryUrl should accept one parameter: `params`. It would be an object passed to `fetch` method
  // getUpdateUrl should accept one parameter: `entry`. It would be an object passed to `update` method
  return {
    async fetch({ commit }, params) {
      commit('startFetch')
      const url = getQueryUrl({ params })
      try {
        const response = await http.getAuthed(url)
        let entries, totalCount
        if (queryIsPaginated) {
          entries = response.data.results
          totalCount = response.data.count
        } else {
          entries = response.data
        }
        commit('setEntries', { entries, totalCount })
      } finally {
        commit('stopFetch')
      }
    },

    async add({ commit }, { entry }) {
      commit('startAdd')
      const url = getAddUrl(entry)
      try {
        const response = await http.postAuthed(url, entry)
        commit('addEntry', { entry: response.data })
        return response
      } finally {
        commit('stopAdd')
      }
    },

    async update({ commit }, { entry }) {
      commit('startUpdate')
      const url = getUpdateUrl(entry)
      try {
        const response = await http.postAuthed(url, entry)
        commit('update', { entry: response.data })
      } finally {
        commit('stopUpdate')
      }
    },
  }
}
